import { machineTechniciansRouteStore } from '../domain/store';

import { listMachineTechnicians } from './index';

export default (e) => {
  machineTechniciansRouteStore.setValue('filterValue', e.target.value);
  machineTechniciansRouteStore.setValue('currentPage', 1);
  return listMachineTechnicians();
};
